export default __webpack_public_path__ + "static/media/left-arrow.aca62b60.svg";